enum ActionTypes {
    DISPLAY_NOTIFICATION = 'DISPLAY_NOTIFICATION',
    HIDE_NOTIFICATION = 'HIDE_NOTIFICATION',
}

export type ActionType = keyof typeof ActionTypes;

export default ActionTypes;
